import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";

export const Button = styled.button<{
  action?: boolean;
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  disabled?: boolean;
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  alignRight?: boolean;
  width?: number;
}>`
  border-radius: 8px;
  font-family: ${FontFamily.MontserratRegular}, Helvetica;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 1px solid;

  margin-top: ${(props) => props.marginTop || 0}px;
  margin-right: ${(props) => props.marginRight || 0}px;
  margin-bottom: ${(props) => props.marginBottom || 0}px;
  margin-left: ${(props) => props.marginLeft || 0}px;

  ${(props) => {
    switch (props.size) {
      case "small":
        return `
          padding: 8px 16px;
          font-size: ${FontSize.Standard};
          max-height: 36px;
        `;
      case "large":
        return `
          padding: 16px 24px;
          font-size: ${FontSize.Large};
          max-height: 56px;
        `;
      default:
        return `
          padding: 12px 20px;
          font-size: ${FontSize.Standard};
          max-height: 48px;
        `;
    }
  }}

  width: ${(props) =>
    props.width ? props.width + "px" : props.fullWidth ? "100%" :  "auto"};

  ${(props) =>
    props.action
      ? `
    background: #6b7280;
    color: ${Color.White};
    border-color: #6b7280;
    
    &:hover:not(:disabled) {
      background: #4b5563;
      border-color: #4b5563;
    }
    
    &:active:not(:disabled) {
      background: #374151;
      border-color: #374151;
    }
  `
      : `
    background: transparent;
    color: #6b7280;
    border-color: #d1d5db;
    
    &:hover:not(:disabled) {
      background: #f9fafb;
      border-color: #9ca3af;
      color: #4b5563;
    }
    
    &:active:not(:disabled) {
      background: #f3f4f6;
      border-color: #6b7280;
      color: #374151;
    }
  `}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus:not(:disabled) {
    box-shadow: 0 0 0 2px rgba(107, 114, 128, 0.2);
  }

  ${(props) =>
    props.alignRight &&
    `
    margin-left: auto;
    display: block;
  `}
`;
